import { Typography, List, ListItem, ListItemText, Box, Card, CardContent, Grid, Chip } from '@mui/material';
import SEO from 'features/shared/components/common/SEO';

export default function VideoVigilancia(){
  return (
    <>
      <SEO 
        title="Video Vigilancia CCTV | Rolsys Solutions"
        description="Servicios de consultoría, soporte, venta e instalación de sistemas de Video Vigilancia y CCTV para tu hogar o negocio."
      />

      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
          <Typography variant="h3" sx={{ fontWeight:800 }}>
            Video Vigilancia y CCTV
          </Typography>
          <Chip label="Soluciones Integrales" color="primary" />
        </Box>

        <Typography variant="h6" sx={{ mb: 4, color: 'text.secondary' }}>
          Consultoría, soporte, venta e instalación de sistemas de seguridad para proteger lo que más importa
        </Typography>

        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Card elevation={0} sx={{ border: '1px solid #eee', mb: 3 }}>
              <CardContent>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                  Nuestros Servicios
                </Typography>
                <List>
                  <ListItem>
                    <ListItemText 
                      primary="Consultoría y Diseño"
                      secondary="Asesoría experta para diseñar el sistema de vigilancia ideal según tus necesidades y presupuesto."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="Venta de Equipo"
                      secondary="Distribuimos las mejores marcas de cámaras, DVRs, NVRs y accesorios con garantía."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="Instalación Profesional"
                      secondary="Técnicos certificados para una instalación estética, funcional y segura."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="Soporte y Mantenimiento"
                      secondary="Mantenimiento preventivo y correctivo para asegurar que tu sistema siempre esté en línea."
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>

            <Card elevation={0} sx={{ border: '1px solid #eee' }}>
              <CardContent>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                  Beneficios para ti
                </Typography>
                <List>
                  <ListItem>
                    <ListItemText primary="Monitoreo en tiempo real desde tu smartphone o computadora." />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Disuasión efectiva contra robos e incidentes." />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Evidencia en video de alta resolución (HD y 4K)." />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Integración con otros sistemas de seguridad." />
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card elevation={0} sx={{ border: '1px solid #eee' }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                  Detalles del Servicio
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  <strong>Cobertura:</strong> Instalaciones en CDMX y Área Metropolitana. Venta a nivel nacional.
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  <strong>Garantía:</strong> Equipos y mano de obra garantizados.
                </Typography>
                <Typography variant="body2">
                  <strong>Entregables:</strong> Sistema configurado, capacitación de uso y app móvil vinculada.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
